export function isObject(value: unknown): value is object {
    return Object.prototype.toString.call(value) === '[object Object]';
}

export function isArray(value: unknown): value is unknown[] {
    return Array.isArray(value);
}

export function isBoolean(value: unknown): value is boolean {
    return typeof value === 'boolean' || value instanceof Boolean;
}

export function isNumber(value: unknown): value is number {
    return typeof value === 'number' && isFinite(value);
}

export function isString(value: unknown): value is string {
    return typeof value === 'string' || value instanceof String;
}